import pt_BR from '@/lang/pt_BR'
import en from '@/lang/en'
import es from '@/lang/es'

export const languages = {
    pt_BR,
    en,
    es
}
